<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div id="examples">
      <vs-tabs>
        <vs-tab v-for="(frame, index) in frameSource" :key="index" :label="frame.name" icon-pack="feather" icon="icon-home">
          <div class="iframe-wrapper">
            <div class="iframe-loading" v-if="frame.iframeLoading">iframe loading...</div>
            <vue-friendly-iframe
              :ref="iframeEl +'-'+ frame.id"
              :style="{ 'display' : frame.iframeLoading ? 'none' : 'block' }"
              :src="frame.src"
              @load="onLoad(frame)"
              @iframe-load="onIframeLoad"
              frameborder="0"
              gesture="media"
              allow="encrypted-media"
              referrerpolicy="origin"
            ></vue-friendly-iframe>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>


<script>
import VueFriendlyIframe from "vue-friendly-iframe";

export default {
  components: {},
  data() {
    return {
      frameSource: [{
        id:"1",
        name:"Noon",
        logo: "",
        src:
          "http://screenshot.priceeye.nextorbit.com.s3-website.ap-south-1.amazonaws.com/images/3840133893.html",
        iframeLoading: true
      }, {
        id:"2",
        name:"Axiom",
        logo: "",
        src:
          "www.google.com",
          // "http://screenshot.priceeye.nextorbit.com.s3-website.ap-south-1.amazonaws.com/images/36379093.html",
        iframeLoading: true
      }, {
        id:"3",
        name:"Amazon",
        logo: "",
        src:
          "http://screenshot.priceeye.nextorbit.com.s3-website.ap-south-1.amazonaws.com/images/3938312993.html",
        iframeLoading: true
      }]
    };
  },
  watch: {},
  computed: {},
  methods: {
    onLoad(frame) {
      // console.log("iframe loaded", frame.name);
      frame.iframeLoading = false;
    },
    onIframeLoad() {
      // console.log("iframe loaded");
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
#examples {
  .iframe-wrapper {
    border: 1px solid rgb(247, 247, 247);
    height: 600px;
    .vue-friendly-iframe {
      height: 100%;
      width: 100%;
      iframe {
        height: 100%;
        width: 100%;
      }
    }
  }
}
</style>